import { curry, has } from 'ramda'

/**
 * renameKey :: String -> String -> Object -> Object
 */
export default curry((previousName, newName, previousObject) => {
  const { [previousName]: previous, ...object } = previousObject
  return {
    ...(has(previousName)(previousObject) ? { [newName]: previous } : {}),
    ...object,
  }
})
